import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {GuiZoneService, NotificationsService} from '@catcore/services';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {StyleType} from '@catui/types';
import {SelectItem} from 'primeng/primeng';
import {EntityProperty} from "@catmodules/model-editor/types";
import {AbstractControl, FormArray, FormControl} from "@angular/forms";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {EntitySchemaService} from "@catcore/services/entity-schema.service";
import * as $ from "jquery";
// import { trigger, transition, animate, style } from '@angular/animations'

interface ListItem {
  label: string;
  raw: string;
}

@Component({
  selector: 'catapp-add-to-relation',
  templateUrl: './add-to-relation.component.html',
  styleUrls: ['./add-to-relation.component.scss']
})
export class AddToRelationComponent implements OnInit {
  @ViewChild('hoverDiv') hoverDivActual: ElementRef;

  @Output() afterAdd = new EventEmitter();

  selectableZones: SelectItem[] = [];
  styleType = StyleType;

  availableZones: any;
  children: ListItem[];
  parents: ListItem[];
  affectedZone: any;

  selectableEntities: Object[] = [];
  selectedEntities: Set<Object> = new Set<Object>();

  control: AbstractControl;
  prop: EntityProperty;
  createLabelFromData: (data: Object|string, prop: EntityProperty) => string;
  createHoverDivForObject: (entity: Object) => HTMLDivElement = null;
  public hoverDiv: HTMLDivElement = null;

  onAddOrChange: (selectedEntities: Set<Object>) => void;

  constructor(private _guiZoneService: GuiZoneService,
              private _notification: NotificationsService,
              private _activeModal: ActiveModal,
              private genericResourceService: GenericResourceService,
              private entitySchemaService: EntitySchemaService) {
  }

  ngOnInit() {
    // this.selectableZones = this.buildSelectableZones();
      const uri: string = this.prop.type.collection ?
          this.prop.type.collection_value_type.resource_uri :
          this.prop.type.resource_uri;
      const resourceService = this.genericResourceService.findServiceForResource(
          this.entitySchemaService.BASE + '/' + uri
      );
      // resourceService.load();
      let excludedUris: string[] = [];
      if (this.control instanceof FormArray) {
          this.control.controls.forEach((subControl: FormControl) => {
              excludedUris.push(subControl.value);
          });
      } else {
          excludedUris.push(this.control.value);
      }
      const result = resourceService.getCurrent().subscribe((resource: any) => {
          if (resource) {
              resource._embedded.item.forEach((entity) => {
                  if (!excludedUris.includes(entity['_links']['self']['href'])) {
                    this.selectableEntities.push(entity);
                  }
              });
          }
          // ...
      });
      resourceService.load();
  }

  addOrRemove(entity: Object, event: Event) {
      const div: HTMLDivElement = event.currentTarget as HTMLDivElement;
      const uri: string = entity['_links']['self']['href'];
      if (this.selectedEntities.has(entity)) {
          // Remove
          this.selectedEntities.delete(entity);
          div.classList.remove('selected');
      } else {
          // Add
          if (!this.prop.type.collection) {
              for (let i = 0; i < div.parentElement.children.length; i++) {
                  div.parentElement.children.item(i).classList.remove('selected');
              }
          }
          this.selectedEntities.add(entity);
          div.classList.add('selected');
      }
  }

  addSelected(event: Event) {
      this.onAddOrChange(this.selectedEntities);
  }

  onMouseEntersItem(value: Object, event: Event) {
      if (!this.createHoverDivForObject) return;
      this.hoverDiv = this.createHoverDivForObject(value);
      setTimeout(() => {
          const hoverDiv = $("#hoverDiv").get(0) as HTMLDivElement;
          if (!hoverDiv) return;
          hoverDiv.style.right = (window.innerWidth - $(hoverDiv.parentElement).offset().left) + "px";
          hoverDiv.style.top = ((window.innerHeight - hoverDiv.clientHeight) / 2) + "px";
          hoverDiv.style.visibility = "visible";
      }, 650);
  }

  /**
   * Closes the modal
   */
  close() {
    this._activeModal.close();
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/model-editor/components/add-to-relation.component.ts